import { DatabaseService } from './../../../database/database.service';
import { Component, Input, OnInit, AfterContentInit, HostListener, Output, EventEmitter, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-cx-dropdown-container',
  templateUrl: './cx-dropdown-container.component.html',
  styleUrls: ['./cx-dropdown-container.component.scss']
})
export class CxDropdownContainerComponent implements OnInit, AfterContentInit {
  // Public props
  public isOpen = false;

  // Private props
  public thisElementClicked = false;

  // Inputs
  @Input() dropDownLabel: string;

  @Input() isLastCardItem: boolean;

  @Input() presentismo: string;

  @Input() motivoCierre: any;

  @Input() asistencia: any;

  @Input() labelPresentismo: string;

  @Output() motivoCierreEvent =  new EventEmitter<any>();

  @Output() presentismoCierreEvent =  new EventEmitter<any>();
  
  motivesItemList: any;
  presentismoItemList: any;
  ausentismoItemList: any;
  firma: string;
  

  @HostListener('click', ['$event'])
  private onLocalClick(event: Event): void  {
    this.thisElementClicked = true;
  }

  @HostListener('document:click', ['$event'])
  private onClick(event: Event): void  {
    if (!this.thisElementClicked) {
      this.focusOut();
    }
    this.thisElementClicked = false;
  }

  constructor(private databaseService: DatabaseService ){

  }

  ngOnInit(): void {
    this.setMotivos();
    this.setPresentismoList();
    this.setAusentismoList();
    this.setLabelPresentismo();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.changeLabelPresentismo(changes.asistencia);
  }


  setLabelPresentismo(){
    if(this.presentismo){
      this.labelPresentismo = "Presente";
    }else if (this.motivoCierre){
      this.labelPresentismo = "Ausente";
    }else{
      this.labelPresentismo = "Asistencia";
    }
  }

  changeLabelPresentismo(asistencia: any){
    if(asistencia.currentValue === "Presente"){
      this.labelPresentismo = "Presente";
    }else if(asistencia.currentValue === "Ausente"){
      this.labelPresentismo = "Ausente";
    }else{
      this.labelPresentismo = "Asistencia";
    }
  }

  ngAfterContentInit(): void { }

  private async setMotivos(): Promise<void> {
    this.motivesItemList = await this.databaseService.getAllMotivosCierreFromOfflineDB();
  }

  private async setPresentismoList(): Promise<void>  {
    this.presentismoItemList = [{id: 1, descripcion: 'Presente'},{id: 2, descripcion: 'Ausente' }];
  }

  private async setAusentismoList(): Promise<void>  {
    this.ausentismoItemList = [{id: 1, descripcion: 'Presente' }, {id: 3, descripcion: 'Anular Ausencia'}];
  }

  public openMenu(): void {
    this.isOpen = !this.isOpen;
  }

  private focusOut(): void  {
    this.isOpen = false;
  }

  action($event): void {
    this.motivoCierreEvent.emit($event);
  }

  actionPresentismo($event): void {
    this.presentismoCierreEvent.emit($event);
  }


}
